import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { filterLocationUrl, filterSectorByIndutry } from '../../Config/config';
import { PeFilterContext } from '../../Contexts/PeFilterContext';
import { TableHeaderContext } from '../../Contexts/TableHeaderContext';
import { UserContext } from '../../Contexts/UserContext';
import AcquirerDealRangeFilter from '../RefineSearchComponents/AcquirerDealRangeFilter';
import CityFilter from '../RefineSearchComponents/CityFilter';
import IndustryFilter from '../RefineSearchComponents/IndustryFilter';
import SectorFilter from '../RefineSearchComponents/SectorFilter';
import { TableDataContext } from '../../Contexts/TableDataContext';
import Constants from '../../Constants';
import ToggleButton from "../RefineSearchComponents/ToggleAndOrSwitch";
import TargetCompany from '../RefineSearchComponents/TargetCompany';
import Acquirers from '../RefineSearchComponents/Acquirers';
import LAdvisor from '../RefineSearchComponents/lAdvisor';
import TAdvisor from '../RefineSearchComponents/tAdvisor';
import {filterTargetCompany ,filterAcquirers,filterlAdvisors,filtertAdvisors} from "../../Config/config"
import { IoMdArrowDropdown, IoMdArrowDropright } from "react-icons/io";

/**
 * The `MaAdvisorRefineSearch` function is a React component that renders a form for refining search
 * filters in a mergers and acquisitions advisor application.
 * @returns The function `MaAdvisorRefineSearch` returns a JSX element.
 */
function MaAdvisorRefineSearch({ customPathname, adviosrType }) {
    const location = useLocation();
    console.log(location.pathname ,"huhuhkhg" , customPathname)
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const isFromGlobalSearch = ()=> refineSearchFilters[pathname]?.globalSearch?.length > 0 ? true : false
    const isFromSearchedList = ()=> refineSearchFilters[customPathname]?.globalSearch?.length > 0 ? true : false
    const { setrefineSearchFilters,SwitchState,setSwitchState, onErrorHandler, refineSearchFilters,dropdown,Sectors, setSectors, MinAcquirerDealRange, MaxAcquirerDealRange,setDbDropdown,dbDropdown, setMonthPickerValue,TargetCompanyOptions,setTargetCompanyOptions , setAcquirersOptions ,AcquirersOptions,setlAdvisorsOptions , lAdvisorsOptions , tAdvisorsOptions ,settAdvisorsOptions } = useContext(PeFilterContext);
    const { setCurrentPage } = useContext(TableDataContext);
    const { getToken } = useContext(UserContext);
    const [select, setSelected] = useState(0);

    const [IndustriesOptions, setIndustriesOptions] = useState([])
    const [SectorOptions, setSectorOptions] = useState([])
    const [CityOptions, setCityOptions] = useState([])
    const [MinDealRangeOptions, setMinDealRangeOptions] = useState([])
    const [MaxDealRangeOptions, setMaxDealRangeOptions] = useState([])


   /**
    * The function `applyFilter` updates the refine search filters based on the selected industries,
    * city, sectors, and deal size options.
    */
    const applyFilter = () => {
        const selectedIndustries = IndustriesOptions.filter(industry => industry.isChecked);
        const selectedCity = CityOptions?.filter(option => option.isChecked);
        const selectedSectors = Sectors.filter(option => option.isChecked);
        const minDealRange = MinDealRangeOptions?.filter(option => option.isChecked)?.at(0) ?? null;
        const maxDealRange = MaxDealRangeOptions?.filter(option => option.isChecked)?.at(0) ?? null;
        const selectedOperators = SwitchState;
        const selectedAcquirers = AcquirersOptions?.filter(option => option.isChecked); 
        const selectedlAdvisors = lAdvisorsOptions?.filter(option => option.isChecked);
        const selectedTargetCompany = TargetCompanyOptions?.filter(option => option.isChecked); 
        const selectedtAdvisors = tAdvisorsOptions?.filter(option => option.isChecked);


        setrefineSearchFilters(prev => ({
            ...prev,
            [customPathname]: {
                ...prev[customPathname],
                industry: selectedIndustries,
                sector: selectedSectors,
                acquirers: selectedAcquirers,
                ladvisors: selectedlAdvisors,
                tadvisors: selectedtAdvisors,
                target_company:selectedTargetCompany,
                city: selectedCity,
                operator: selectedOperators,
                dealSize: minDealRange != null && maxDealRange != null ? [minDealRange, maxDealRange] : [],
            },
        }))
    }

  /**
   * The function `resetFilter` resets a specific filter in the `refineSearchFilters` object by setting
   * its value to an empty object.
   */
    const resetFilter = () => {
        setrefineSearchFilters(prev => ({
            ...prev,
            [customPathname]: {}
        }))
        setTargetCompanyOptions([]);
        setAcquirersOptions([]);
        setlAdvisorsOptions([]);
        setSectors([]);
        settAdvisorsOptions([]);
    }


    // Submitting Refine Search Form 
   /**
    * The function `refineSearchFilter` updates search filters, resets month picker value, sets current
    * page to 1, applies filters, selects the first option, and navigates to a custom pathname if the
    * current pathname is different.
    * @param event - The event parameter is an object that represents the event that triggered the
    * function. In this case, it is used to prevent the default behavior of the event (e.g., preventing
    * a form submission) by calling the `preventDefault()` method on the event object.
    */
    const refineSearchFilter = (event) => {
        event.preventDefault();
        setrefineSearchFilters(prev => ({
            ...prev,
            [customPathname]: {globalSearch:[]}
        }))
        if(isFromGlobalSearch() || isFromSearchedList()){
        setMonthPickerValue(Constants.initialMonthRange)
        }
        setCurrentPage(1);
        applyFilter();
        setSelected(0)
        if (location.pathname != customPathname) {
            navigate(customPathname)
        }

    }

   /**
    * The function `onResetClick` resets the current page, filters, and navigates to a custom pathname
    * if it is not already the current location.
    * @param event - The event parameter is an object that represents the event that triggered the
    * function. In this case, it is likely a click event on a reset button.
    */
    const onResetClick = (event) => {
        event.preventDefault();
        setCurrentPage(1);
        resetFilter()
        if (location.pathname != customPathname) {
            navigate(customPathname)
        }
    }

   /**
    * The function `accordionClick` sets the selected value to either 0 or the provided value.
    * @param val - The `val` parameter is a value that is passed to the `accordionClick` function. It
    * is used to determine whether the accordion should be selected or deselected.
    */
    const accordionClick = (val) => {
        if (val === select) {
            setSelected(0);
        } else {
            setSelected(val);
        }
    };

    // useEffect(() => {
    //     const ids = IndustriesOptions.filter(industry => industry.isChecked)?.map(option => option.id);

    //     if (ids?.length > 0) {
    //         const sectorsIds = SectorOptions.filter(sector => sector.isChecked)?.map(option => option.id)
    //         axios.post(filterSectorByIndutry, {
    //             "industry": ids,
    //             category: "investments"
    //         }, {
    //             headers: {
    //                 "Authorization": getToken()
    //             }
    //         }).then(response => {
    //             if (response.status === 200) {
    //                 setSectors(response.data?.data?.map(option => ({ ...option, isChecked: sectorsIds.includes(option.id) })))
    //             } else {
    //                 setSectors([])
    //             }
    //         }).catch(onErrorHandler)
    //     } else {
    //         setSectors([])
    //     }

    // }, [IndustriesOptions])

    // useEffect(()=>{
    //     fetch(filterTargetCompany, {
    //         method: 'POST',
    //         headers: {
    //             'Content-Type': 'application/json'
    //         },
    //         body: JSON.stringify({ search_key: "initial" })
    //         })
    //         .then(response => {
    //         if (!response.ok) {
    //             throw new Error('Network response was not ok');
    //         }
    //         return response.json();
    //         })
    //         .then(data => {
    //         setTargetCompanyOptions(data?.results);
    //         console.log(TargetCompanyOptions,"vbvb")
    //         })
    //         .catch(error => {
    //         console.error('Error fetching data:', error);
    //         });
    //     },[])

    //     useEffect(()=>{
    //         fetch(filterAcquirers, {
    //             method: 'POST',
    //             headers: {
    //                 'Content-Type': 'application/json'
    //             },
    //             body: JSON.stringify({ search_key: "initial" })
    //             })
    //             .then(response => {
    //             if (!response.ok) {
    //                 throw new Error('Network response was not ok');
    //             }
    //             return response.json();
    //             })
    //             .then(data => {
    //                 setAcquirersOptions(data?.results);
    //             })
    //             .catch(error => {
    //             console.error('Error fetching data:', error);
    //             });
    //         },[])

    //         useEffect(()=>{
    //             fetch(filterlAdvisors, {
    //                 method: 'POST',
    //                 headers: {
    //                     'Content-Type': 'application/json'
    //                 },
    //                 body: JSON.stringify({ search_key: "initial" })
    //                 })
    //                 .then(response => {
    //                 if (!response.ok) {
    //                     throw new Error('Network response was not ok');
    //                 }
    //                 return response.json();
    //                 })
    //                 .then(data => {
    //                     setlAdvisorsOptions(data?.results);
    //                 })
    //                 .catch(error => {
    //                 console.error('Error fetching data:', error);
    //                 });
    //             },[])

    //             useEffect(()=>{
    //                 fetch(filtertAdvisors, {
    //                     method: 'POST',
    //                     headers: {
    //                         'Content-Type': 'application/json'
    //                     },
    //                     body: JSON.stringify({ search_key: "initial" })
    //                     })
    //                     .then(response => {
    //                     if (!response.ok) {
    //                         throw new Error('Network response was not ok');
    //                     }
    //                     return response.json();
    //                     })
    //                     .then(data => {
    //                         settAdvisorsOptions(data?.results);
    //                     })
    //                     .catch(error => {
    //                     console.error('Error fetching data:', error);
    //                     });
    //                 },[])


    useEffect(() => {

        const cityIds = refineSearchFilters[customPathname]?.city?.map(value => value.id) ?? [];

        axios.post(filterLocationUrl, {
            country: [],
            region: [],
            state: [],
            city: [],

        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then(response => {
            if (response.status === 200) {
                setCityOptions(response.data.city?.map(option => ({ ...option, isChecked: cityIds.includes(option.id) })))
            }
        }).catch(onErrorHandler)
    }, [refineSearchFilters])

    const toggleSwitchState = () => {
        setSwitchState(prevState => prevState === "and" ? "or" : "and");
    };

    const handleDbToggle = () => {
        setDbDropdown(!dbDropdown);
    };

    // State for managing which filter section is active
    const [activeFilterSection, setActiveFilterSection] = useState("keyword");
    
    // State for managing which individual filter popup is open
    const [openFilterPopup, setOpenFilterPopup] = useState(null);

    // Helper functions to count applied filters for each section
    const getTargetFiltersCount = () => {
        let count = 0;
        if (IndustriesOptions?.filter(option => option.isChecked).length > 0) count++;
        if (Sectors?.filter(option => option.isChecked).length > 0) count++;
        if (CityOptions?.filter(option => option.isChecked).length > 0) count++;
        return count;
    };

    const getDealFiltersCount = () => {
        let count = 0;
        if (MinDealRangeOptions?.filter(option => option.isChecked).length > 0 || MaxDealRangeOptions?.filter(option => option.isChecked).length > 0) count++;
        return count;
    };

    const getKeywordFiltersCount = () => {
        let count = 0;
        if (TargetCompanyOptions?.filter(option => option.isChecked).length > 0) count++;
        if (AcquirersOptions?.filter(option => option.isChecked).length > 0) count++;
        if (lAdvisorsOptions?.filter(option => option.isChecked).length > 0) count++;
        if (tAdvisorsOptions?.filter(option => option.isChecked).length > 0) count++;
        return count;
    };

    return (
        <div className="bg-white">
            <div className="h-full no-scrollbar">
                <form onSubmit={refineSearchFilter} onReset={onResetClick} className="h-full w-full">
                    <main className="h-full w-full py-4">
                        <div className="flex flex-col md:grid md:grid-cols-8 gap-2 md:gap-4 h-full">
                            {/* Left column - Section Headers */}
                            <div className="flex flex-row md:flex-col gap-1 md:gap-2 border-b md:border-b-0 md:border-r border-gray-300 pb-2 md:pb-0 md:pr-4 md:max-w-[320px] md:col-span-2 items-baseline md:items-stretch  flex-wrap md:flex-nowrap">

                                {/* Keyword Search Section */}
                                <div 
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors w-auto md:w-full flex items-center justify-between gap-2 ${
                                        activeFilterSection === 'keyword' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'keyword' ? null : 'keyword')}
                                >
                                    <div className="flex items-center gap-1 md:gap-2">
                                        <span className="text-xs md:text-base font-medium">Keyword Search</span>
                                        {getKeywordFiltersCount() > 0 && (
                                            <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center ${activeFilterSection === 'keyword' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                {getKeywordFiltersCount()}
                                            </span>
                                        )}
                                    </div>
                                    {activeFilterSection === 'keyword' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                </div>

                                {/* Deal Section */}
                                <div 
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors w-auto md:w-full flex items-center justify-between gap-2 ${
                                        activeFilterSection === 'deal' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'deal' ? null : 'deal')}
                                >
                                    <div className="flex items-center gap-1 md:gap-2">
                                        <span className="text-xs md:text-base font-medium">Deal</span>
                                        {getDealFiltersCount() > 0 && (
                                            <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center ${activeFilterSection === 'deal' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                {getDealFiltersCount()}
                                            </span>
                                        )}
                                    </div>
                                    {activeFilterSection === 'deal' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                </div>

                                {/* Target Section */}
                                <div 
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors w-auto md:w-full flex items-center justify-between gap-2 ${
                                        activeFilterSection === 'target' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'target' ? null : 'target')}
                                >
                                    <div className="flex items-center gap-1 md:gap-2">
                                        <span className="text-xs md:text-base font-medium">Target</span>
                                        {getTargetFiltersCount() > 0 && (
                                            <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center ${activeFilterSection === 'target' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                {getTargetFiltersCount()}
                                            </span>
                                        )}
                                    </div>
                                    {activeFilterSection === 'target' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                </div>
                            </div>
                            
                            {/* Right column - Filter Content */}
                            <div className="overflow-y-auto md:overflow-hidden mt-4 md:mt-0 h-full md:max-h-none pb-20 md:pb-0 md:col-span-6">
                                {/* Target Content */}
                                <div className={`grid grid-cols-1 sm:grid-cols-2 gap-4 gap-y-4 md:gap-y-8 ${activeFilterSection === 'target' ? '' : 'hidden'}`}>
                                    <IndustryFilter
                                        IndustriesOptions={IndustriesOptions}
                                        setIndustriesOptions={setIndustriesOptions}
                                        customPathname={customPathname}
                                        label="Industry"
                                        isPopupOpen={openFilterPopup === 'industry'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'industry' : null)}
                                    />
                                    <SectorFilter
                                        setOptions={setSectors}
                                        options={Sectors}
                                        label="Sector"
                                        customPathname={customPathname}
                                    />
                                    <CityFilter
                                        CityOptions={CityOptions}
                                        setCityOptions={setCityOptions}
                                        customPathname={customPathname}
                                        label="City(of Target Company)"
                                        isPopupOpen={openFilterPopup === 'city'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'city' : null)}
                                    />
                                </div>

                                {/* Deal Content */}
                                <div className={`grid grid-cols-1 sm:grid-cols-2 gap-4 gap-y-4 md:gap-y-8 ${activeFilterSection === 'deal' ? '' : 'hidden'}`}>
                                    <AcquirerDealRangeFilter
                                        dataPath="dealSize"
                                        customPathname={customPathname}
                                        MinDealOptions={MinDealRangeOptions}
                                        setMinDealOptions={setMinDealRangeOptions}
                                        MaxDealOptions={MaxDealRangeOptions}
                                        MinDealRange={MinAcquirerDealRange}
                                        MaxDealrange={MaxAcquirerDealRange}
                                        label="Deal Size ($M)"
                                        setMaxDealOptions={setMaxDealRangeOptions}
                                        isPopupOpen={openFilterPopup === 'dealSize'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'dealSize' : null)}
                                    />
                                </div>

                                {/* Keyword Search Content */}
                                <div className={`w-full md:w-1/2 mt-4 md:mt-0 ${activeFilterSection === 'keyword' ? '' : 'hidden'}`}>
                                    <div className="space-y-4">
                                        <TargetCompany 
                                            options={TargetCompanyOptions}
                                            setOptions={setTargetCompanyOptions}
                                            customPathname={customPathname}
                                            label="Target Company"
                                        />

                                        <Acquirers 
                                            options={AcquirersOptions}
                                            setOptions={setAcquirersOptions}
                                            customPathname={customPathname}
                                            label="Acquirers"
                                        />

                                        {customPathname !== "/ma/transaction-advisors" ? (
                                            <LAdvisor 
                                                options={lAdvisorsOptions}
                                                setOptions={setlAdvisorsOptions}
                                                customPathname={customPathname}
                                                label="Legal Advisors"
                                            />
                                        ) : (
                                            <TAdvisor 
                                                options={tAdvisorsOptions}
                                                setOptions={settAdvisorsOptions}
                                                label="Transaction Advisors"
                                                customPathname={customPathname}
                                            />
                                        )}
                                    </div>
                                </div>

                                {/* Empty State */}
                                <div className={`flex items-center justify-center h-40 text-gray-500 ${activeFilterSection ? 'hidden' : ''}`}>
                                    <p>Select a filter category from the left to view available filters</p>
                                </div>
                            </div>
                        </div>
                    </main>
                </form>
            </div>
        </div>
    )
}

export default MaAdvisorRefineSearch
